module.exports = __webpack_public_path__ + "static/img/contant_8.d76b5a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_4/contant_8.jpg
// module id = AyAt
// module chunks = 0